/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMessageAttachement = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15.221 4.277c0-.935-.364-1.813-1.025-2.475a3.507 3.507 0 0 0-4.95-.002l-.709.706a.5.5 0 0 0 .706.709l.709-.707a2.504 2.504 0 0 1 3.537.002c.472.472.732 1.1.732 1.767s-.26 1.296-.732 1.768l-1.577 1.576-.003.002L9.952 9.58l-.001.002-3.905 3.906c-.944.945-2.59.945-3.535 0a2.503 2.503 0 0 1 0-3.536l4.342-4.344a.971.971 0 0 1 1.303.053.983.983 0 0 1 0 1.387l-3.482 3.483a.5.5 0 0 0 .708.707l3.482-3.483a1.984 1.984 0 0 0-.001-2.801c-.631-.631-1.689-.735-2.329-.336-.215.134-.451.383-.451.383L1.805 9.245a3.507 3.507 0 0 0 .001 4.951A3.476 3.476 0 0 0 4.28 15.22c.935 0 1.813-.364 2.474-1.025l7.443-7.443a3.475 3.475 0 0 0 1.025-2.475z"
    />
  </svg>
);

IconMessageAttachement.displayName = 'IconMessageAttachement';

IconMessageAttachement.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMessageAttachement);
IconMessageAttachement.displayName = 'IconMessageAttachement';
